<template>
  <div>
    <!-- 신원 인증 필수 안내 -->
    <vs-popup
      title="고객확인의무 시행 안내"
      :button-close-hidden="true"
      :active.sync="doauthnotimodal"
      class="large-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p>
            「특정 금융거래정보의 보고 및 이용 등에 관한 법률」및 동법 시행령에
            따라 고객확인의무 이행이 의무화 되었습니다.
          </p>
          <div class="gray-box mt12">
            <p>
              이에 플라이빗의 서비스를 계속해서 이용하기 위해서는 반드시 신원
              인증을 완료해 주셔야 하며,<br />
            </p>
            <p class="mt8">
              신원 인증이 완료되지 않은 상태에서는 거래소, 토큰 세일, 해시파워,
              입출금 등 서비스 이용이 제한됩니다.
            </p>
          </div>
          <div class="mt12">
            <p>
              신원 인증은
              <span style="font-weight: 500;">{{ "플라이빗 앱 (App)" }}</span
              >에서 가능합니다.
            </p>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <!-- <button @click="doauthnotimodal = false">확인</button> -->
        <button @click="closeAuthIDModal" class="oneButton">
          {{ "확인" }}
        </button>
      </div>
    </vs-popup>
    <!-- //신원 인증 필수 안내 -->
    <!-- wLF. 특정금융거래정보법 시행에 따른 거래 거절 안내-->
    <vs-popup
      title="특정금융거래정보법 시행에 따른 거래 거절 안내"
      :button-close-hidden="true"
      :active.sync="userwlfmodal"
      class="large-popup"
    >
      <div class="wlfModal text-wrap pb20">
        <div class="text-detail">
          <p>
            특정 금융거래정보의 보고 및 이용 등에 관한 법률 및 관련 규제에
            근거하여 회사의 '거래거절 유형' 대상자로 분류되어 이용하시는 거래에
            대해 거절 처리가 되었습니다.
          </p>
          <p class="mt10">
            {{ "고객센터로 문의바랍니다." }}
          </p>
          <div class="gray-box mt20 ta-c">
            고객센터 운영시간 평일 09:30 ~ 18:30
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeWlfModal">확인</button>
        <button @click="kakaoChat">카카오톡 상담</button>
      </div>
    </vs-popup>
    <!-- //WLF. 특정금융거래정보법 시행에 따른 거래 거절 안내 -->

    <!-- 심사중 -->
    <vs-popup
      title="심사 중 안내"
      :button-close-hidden="true"
      :active.sync="waitingModal"
      class="large-popup"
    >
      <div class="wlfModal text-wrap pb20">
        <div class="text-detail">
          <p>고객확인 심사 중 입니다.</p>
          <p class="mt10">고객센터 문의 바랍니다.</p>
          <div class="gray-box mt20 ta-c">
            고객센터 운영시간 평일 09:30 ~ 18:30
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeAuthIDModal" class="oneButton">확인</button>
      </div>
    </vs-popup>

    <!-- 심사중 - 거래 거절 -->
    <vs-popup
      title="심사 중 안내"
      :button-close-hidden="true"
      :active.sync="rejectOrderModal"
      class="large-popup"
    >
      <div class="wlfModal text-wrap pb20">
        <div class="text-detail">
          <p>고객확인 심사 중 입니다.</p>
          <p class="mt10">
            매매 및 입/출금이 제한되고, 미체결내역 은 취소됩니다.
          </p>
          <p class="mt10">고객센터 문의 바랍니다.</p>
          <div class="gray-box mt20 ta-c">
            고객센터 운영시간 평일 09:30 ~ 18:30
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeAuthIDModal" class="oneButton">
          확인
        </button>
      </div>
    </vs-popup>

    <!-- 고객확인 재이행주기 도래 고객 안내 -->
    <vs-popup
      title="고객확인제도"
      :button-close-hidden="true"
      :active.sync="reauthnotimodal"
      class="large-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p v-if="overReauthDate">
            {{ "고객님의 고객확인제도 재이행 주기가 지났습니다. " }}
          </p>
          <p v-else>
            {{ "고객님의 고객확인제도 재이행 주기가 도래하였습니다." }}
          </p>
          <p class="mt12">
            고객확인을 진행하지 않는 경우,
            <span style="text-decoration: underline; font-weight: bold">
              미체결 주문이 취소되며, 매매/입출금</span
            >이 제한됩니다.
          </p>
          <div class="gray-box mt20 keycolor ta-c">
            재이행주기 도래일 : {{ reauthdate }}
          </div>
          <div class="mt20">
            <p style="font-weight: bold">
              고객확인제도란?
            </p>
            <p>
              금융기관 등이 고객과 금융거래를 하는 때에 자신이 제공하는 금융상품
              또는 서비스가 자금세탁 등에 이용되지 않도록 「특정금융거래정보의
              보고 및 이용 등에 관한 법률」 에 따라 고객의 신원확인 및 검증,
              거래의 목적, 자금의 원천, 실제소유자 확인 등 고객에 대하여 합당한
              주의를 기울이는 것을 말합니다.
            </p>
            <p class="mt10">
              신원 인증은
              <span style="font-weight: bold;">{{ "플라이빗 앱 (App)" }}</span
              >에서 가능합니다.
            </p>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeAuthIDModal" class="oneButton">확인</button>
        <!-- <button @click="movetoreauth">재인증</button> -->
      </div>
    </vs-popup>
    <!-- //고객확인 재이행주기 도래 고객 안내 -->
    <!-- wlf 결재중 -->
    <vs-popup
      title="고객센터 문의 요망"
      :button-close-hidden="true"
      :active.sync="processWlfnotimodal"
      class="large-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <p class="ta-c">
            죄송합니다.<br /><br />회원님의 원활한 서비스 이용을 위해 고객센터
            1:1 문의 또는 우측 하단 채팅으로 문의 바랍니다.
          </p>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="closeModal" class="oneButton">확인</button>
      </div>
    </vs-popup>
    <!-- //wlf 결재중 -->
    <!-- 외국인 주문 금지 -->
    <vs-popup
      title="Service Restriction Notice of Foreigners Residing Overseas"
      :button-close-hidden="true"
      :active.sync="restrictOrderNotiModal"
      class="large-popup"
    >
      <div class="text-wrap" style="overflow-y: scroll">
        <div class="text-detail">
          <p>
            Due to the implementation of the Specified Financial Transaction
            Information Act, Foreigners residing overseas are restricted from
            using service. Please read the details below for further
            information.<br /><br />
            [Notice]<br />
            Target : Foreigners residing overseas (Individuals)<br />
            Detail : Restriction on new membership registration, transaction,
            deposit<br /><br />
            [Notes]<br />
            ​- Foreigners residing Korea who cannot verify their identities with
            mobile phones cannot use the service.<br />
            ​- If you have any problems such as a login failure, please contact
            the customer service center. (Email: help@flybit.com)<br /><br />
            Please make sure to complete the withdrawal of your assets.
          </p>
        </div>
      </div>
      <div class="button-wrap pt7">
        <button @click="restrictOrderNotiModal = false">확인</button>
      </div>
    </vs-popup>
    <!-- // 외국인 주문 금지 -->
  </div>
</template>
<script>
import GlobalEvent from "@/common/Event";
import { mapGetters } from "vuex";
import Moment from "moment";

export default {
  name: "Modals",
  components: {},
  created() {
    // 신원인증 필수 안내 팝업
    GlobalEvent.$on("doAuthNoti", () => {
      console.log("doauthModal-modals");
      this.doauthnotimodal = true;
      this.checkIsGoBack();
    });
    // 고객확인 재이행주기 도래 고객 안내

    GlobalEvent.$on("reAuthNoti", () => {
      console.log("reauthmodal-modals");
      this.reauthnotimodal = true;
      this.checkIsGoBack();
    });
    // 특정금융거래정보법(wlf) 시행에 따른 거래 거절 안내
    GlobalEvent.$on("wlfReject", () => {
      this.userwlfmodal = true;
    });
    // wlf null일 때 (결재중) 팝업
    GlobalEvent.$on("processWlf", () => {
      this.processWlfnotimodal = true;
    });
    // 외국인 주문 금지 팝업
    GlobalEvent.$on("restrictOrder", () => {
      this.restrictOrderNotiModal = true;
    });
    GlobalEvent.$on("waiting", () => {
      this.waitingModal = true;
      this.checkIsGoBack();
    });
    GlobalEvent.$on("rejectOrder", () => {
      this.rejectOrderModal = true;
      this.checkIsGoBack();
    });
  },
  data() {
    return {
      doauthnotimodal: false, // 신원인증 필수 안내
      reauthnotimodal: false, // 고객확인 재이행주기 도래 고객 안내
      userwlfmodal: false, // 특정금융거래정보법 시행에 따른 거래 거절 안내
      processWlfnotimodal: false, // wlf null일 때 (결재중) 팝업
      restrictOrderNotiModal: false, // 외국인 주문 금지 팝업
      isGoBack: false, // 재이행주기 도래 이후 모달 뒤로가기 조건
      waitingModal: false,
      rejectOrderModal: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
      isLogin: "isLogin",
    }),
    // 재이행주기 도래일
    reauthdate() {
      if (this.isLogin) {
        if (
          this.userInfo.dueDiligenceInfo &&
          this.userInfo.dueDiligenceInfo.reAuthDate
        ) {
          return this.userInfo.dueDiligenceInfo.reAuthDate.slice(0, 10);
        }
      }
    },
    // wlf 사유 코드 분기
    wlfcontents() {
      if (this.isLogin && this.userInfo.dueDiligenceInfo) {
        const wlfContents = this.userInfo.dueDiligenceInfo.wlfContents;
        if (wlfContents) {
          switch (wlfContents) {
            case "01":
              return "금융위원회에서 고시하는 금융거래제한대상자";
              break;
            case "02":
              return "FATF 지정 위험국가 국적자 또는 거주자";
              break;
            case "03":
              return "FATF 지정 위험국가 국적자 또는 거주자";
              break;
            case "04":
              return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
              break;
            case "05":
              return "UN에서 지정하는 제재대상자";
              break;
            case "06":
              return "외국의 정치적 주요 인물";
              break;
            case "07":
              return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
              break;
            case "08":
              return "외국의 정부에서 자금세탁행위등의 위험을 우려하여 발표한 금융거래제한 대상자";
              break;
            case "09":
              return "";
              break;
            default:
              return "고객센터에 문의하세요";
              break;
          }
        } else {
          return "고객센터에 문의하세요";
        }
      }
      return;
    },
    overReauthDate() {
      if (this.userInfo.dueDiligenceInfo) {
        const reauthDate = this.userInfo.dueDiligenceInfo.reAuthDate; // 재이행주기 도래일
        if (
          Moment(reauthDate).format("YYYY-MM-DD") <
          Moment().format("YYYY-MM-DD")
        ) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    // WLF 고객 안내 팝업 닫기
    closeUserWLFModal() {
      this.userwlfmodal = false;
    },
    // 인증센터로 이동
    movetoMain() {
      this.doauthnotimodal = false;
      this.reauthnotimodal = false;
      this.$router.push({ name: "Main" });
    },
    // 재이행주기 도래  안내 팝업 닫기
    closeModal() {
      this.reauthnotimodal = false;
      this.userwlfmodal = false;
      this.processWlfnotimodal = false;
    },
    // wlf 팝업 닫기
    closeWlfModal() {
      this.userwlfmodal = false;
      // this.$router.push({ name: "confirm" });
    },
    // 재인증으로 이동
    movetoreauth() {
      this.reauthnotimodal = false;
      this.$router.push({ name: "authInfo" });
    },
    kakaoChat() {
      // 채널 1:1 채팅 버튼을 생성합니다.
      Kakao.Channel.chat({
        channelPublicId: "_CjkSs",
      });
    },
    closeAuthIDModal() {
      if (this.isGoBack) {
        this.$router.go(-1);
      }
      this.reauthnotimodal = false;
      this.doauthnotimodal = false;
      this.waitingModal = false;
      this.rejectOrderModal = false;
    },
    checkIsGoBack() {
      this.isGoBack = false;
      const pathname = window.location.pathname.toLowerCase();
      if (
        pathname.indexOf("/deposit/") !== -1 ||
        pathname.indexOf("/withdraw/") !== -1 ||
        pathname.indexOf("mypage/auth-address") !== -1
      ) {
        this.isGoBack = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
